import React from "react";
import { Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Style from "../../../../../styles/js/StyleCallList.js";
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import List from "@material-ui/core/List";
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import service from "../../../../../plas/services/calls/service.jsx";

import { Container, Draggable } from "react-smooth-dnd";

export default function FormInputs( { form, select, showError, disable, disabled } ) {

  const style = Style()
  const [items, setItems] = React.useState(form.inputs)
  const [updating, setUpdating] = React.useState(false);

  const onDrop = ({ removedIndex, addedIndex }) => {
   if (removedIndex !== addedIndex) {
      setUpdating(true);
      disable(true);

      var original = items;
      var elements = []
      elements.push.apply(elements,items);
      var element = items[removedIndex];
      elements.splice(removedIndex, 1);
      elements.splice(addedIndex, 0, element);
      setItems(elements);

      service.api.inputs.move(form.id, items[removedIndex].id, addedIndex, (response) => {
        if (response.error == null) {
          var newInputs = response.result;
          form.inputs = newInputs;
          setItems(form.inputs);
        } else {
          setItems(original);
          showError(response.error);
        }
        
        setUpdating(false);
        disable(false);
      });
    }
  }

  const deleteInput = (inputId) => {
    setUpdating(true);
    disable(true);

    service.api.inputs.delete(form.id, inputId, (response) => {
      
      if (response.error == null) {
        var newInputs = response.result;
        form.inputs = newInputs;
        setItems(form.inputs);
      } else {
        showError(response.error);
      }

      setUpdating(false);
      disable(false);  
    });
  }

  const createInput = () => {
    setUpdating(true);
    disable(true);

    var input = { configurationId: form.id, name: "Nuevo campo", description: "Sin descripción", typeId: 1};

    service.api.inputs.create(input, (response) => {
      if (response.error == null) {
        input = response.result;
        form.addInput(input);
        setItems(form.inputs);
        select(input.id)
      } else {
        showError(response.error);
      }

      setUpdating(false);
      disable(false);  
    });
  }

  return (
    <div>
      <Card style={{ marginBottom: "15px"}}>
        <div className={style.itemHeader}>
          <Typography className={style.titleInitial}>
            Campos del formulario
          </Typography>
          <div style={{ marginLeft: 'auto' }} >
            { updating ? 
              (
                <Tooltip title="Borrar">
                  <IconButton disabled={true} aria-label="delete" style={{ color: 'white' }}>
                   <CircularProgress color="inherit" size={22}/>
                  </IconButton>
                </Tooltip>
              ) : (
                <div>
                { form.isEditable() ? 
                  (
                    <Tooltip title="Nuevo campo">
                      <IconButton disabled={(updating||disabled)} aria-label="add" style={{ color: 'white' }} onClick={ () => { createInput() }}>
                        <AddIcon font-size="small" />
                      </IconButton>
                    </Tooltip>
                  ) : (null)
                }
                </div>
              )
            }
          </div>
        </div>
        <div>
          <List>
            <Container dragHandleSelector=".drag-handle" lockAxis="y" onDrop={onDrop}>
              {items.map(({ id, name }, index) => (
                <Draggable key={id}>
                  <ListItem>
                    { form.isEditable() ? 
                      (
                        <ListItemIcon className={(updating||disabled) ? "" : "drag-handle"}>
                          <Tooltip title="Mover">
                            <DragHandleIcon/>
                          </Tooltip>
                        </ListItemIcon>
                      ) : (null) 
                    }
                    <ListItemText>{name}</ListItemText>
                    <ListItemSecondaryAction>
                      <ListItemIcon>
                        <Tooltip title="Ver o editar">
                          <IconButton disabled={(updating||disabled)} aria-label="open" onClick={ () => select(id) }>
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                      </ListItemIcon>
                       { form.isEditable() ? 
                        (
                          <ListItemIcon>
                            <Tooltip title="Borrar">
                              <IconButton disabled={(updating||disabled)} aria-label="delete" onClick={ () => deleteInput(id) }>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </ListItemIcon>
                        ) : (null) 
                      }
                    </ListItemSecondaryAction>
                  </ListItem>
                </Draggable>
              ))}
            </Container>
          </List>
        </div>
      </Card>
    </div>

  )

}
